export class AuthErrorMessages {
    public static readonly defaultErrorMessage: string = "Unhandled OAuth event error";

    private static messages: Record<string, string> = {
      discovery_document_load_error: 'Failed to load discovery document error.',
      discovery_document_validation_error: 'Discovery document validation error.',
      session_error: 'Session error.',
      silent_refresh_error: 'Silent refresh error.',
      token_error: 'Token error.',
      token_refresh_error: 'Token refresh error.',
      token_revoke_error: 'Token revoke error.',
      token_validation_error: 'Token validation error.',
      user_profile_load_error: 'User profile load error.',
      code_error: 'Code error.',
      jwks_load_error: 'Jwks load error.'
    };
  
    public static getErrorMessage(eventType: string): string {
      return this.messages[eventType] ?? this.defaultErrorMessage;
    }
  }
  